var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSobreYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 113,
    height: 112,
    viewBox: "0 0 113 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Circle_Button_SIZE_LARGE_STATE_DEFAULT_STYLE_STYLE2_",
    "data-name": "Circle Button [SIZE=LARGE][STATE=DEFAULT][STYLE=STYLE2]",
    transform: "translate(0.366 -0.313)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Area_SIZE:LARGE_STATE:DEFAULT_STYLE:STYLE2_",
    "data-name": "Area [SIZE:LARGE][STATE:DEFAULT][STYLE:STYLE2]",
    width: 113,
    height: 112,
    rx: 56,
    transform: "translate(-0.366 0.312)",
    fill: "#bbe56b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_ICON_feather_archive_SIZE_LARGE_STATE_DEFAULT_STYLE_STYLE2_",
    "data-name": "Icon [ICON=feather/archive][SIZE=LARGE][STATE=DEFAULT][STYLE=STYLE2]",
    transform: "translate(20.783 22.515)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Area_ICON:feather_archive_SIZE:LARGE_STATE:DEFAULT_STYLE:STYLE2_",
    "data-name": "Area [ICON:feather/archive][SIZE:LARGE][STATE:DEFAULT][STYLE:STYLE2]",
    width: 67.1,
    height: 67.1,
    transform: "translate(2.44)",
    fill: "#bbe56b",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(0 8.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_5788e794-8821-4403-9c8f-c831c15f63a1",
    "data-name": "5788e794-8821-4403-9c8f-c831c15f63a1",
    d: "M66.367,11.7a8.418,8.418,0,0,0-5.881-6.059C55.275,4.363,34.426,4.363,34.426,4.363s-20.849,0-26.061,1.395a8.423,8.423,0,0,0-5.878,6.062A87.62,87.62,0,0,0,1.092,27.848,87.975,87.975,0,0,0,2.487,44,8.421,8.421,0,0,0,8.365,49.82c5.212,1.395,26.061,1.395,26.061,1.395s20.849,0,26.061-1.395a8.426,8.426,0,0,0,5.881-6.062,88.26,88.26,0,0,0,1.395-15.91A87.966,87.966,0,0,0,66.367,11.7Z",
    transform: "translate(0.642 -2.631)",
    fill: "#bbe56b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_5788e794-8821-4403-9c8f-c831c15f63a1_-_Contorno",
    "data-name": "5788e794-8821-4403-9c8f-c831c15f63a1 - Contorno",
    d: "M34.158,2.363c.86,0,21.119.015,26.472,1.325l.059.015a10.175,10.175,0,0,1,7.091,7.3q.014.056.024.113a89.937,89.937,0,0,1,1.422,16.462A90.229,90.229,0,0,1,67.8,43.8q-.01.057-.025.114a10.185,10.185,0,0,1-7.09,7.307l-.024.007c-2.291.613-7.465,1.043-15.381,1.278-5.822.173-11.075.175-11.127.175s-5.305,0-11.127-.175c-7.915-.235-13.09-.665-15.381-1.278l-.01,0A10.153,10.153,0,0,1,.553,44.208q-.023-.082-.039-.166A89.953,89.953,0,0,1-.908,27.58,89.571,89.571,0,0,1,.514,11.243q.01-.056.024-.111A10.178,10.178,0,0,1,7.625,3.823l.024-.007C9.94,3.2,15.115,2.773,23.03,2.538,28.852,2.365,34.105,2.363,34.158,2.363ZM59.777,7.045c-1.425-.343-5.115-.8-14.583-1.059-5.774-.157-10.984-.159-11.036-.159-5.73,0-21.488.24-25.6,1.332a6.706,6.706,0,0,0-4.645,4.759A86.093,86.093,0,0,0,2.556,27.571q0,.01,0,.02A86.481,86.481,0,0,0,3.907,43.339,6.69,6.69,0,0,0,8.55,47.88c4.1,1.095,19.875,1.334,25.608,1.334s21.488-.24,25.6-1.332a6.712,6.712,0,0,0,4.647-4.759,86.75,86.75,0,0,0,1.356-15.537c0-.005,0-.011,0-.016A86.459,86.459,0,0,0,64.406,11.8,6.7,6.7,0,0,0,59.777,7.045Z",
    transform: "translate(0.91 -2.363)",
    fill: "#2f2f2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_7a1203a2-4446-4e62-a0ec-e8e04ac9888f",
    "data-name": "7a1203a2-4446-4e62-a0ec-e8e04ac9888f",
    d: "M10.636,29.071,28.06,19.159,10.636,9.25Z",
    transform: "translate(17.614 6.058)",
    fill: "#bbe56b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_7a1203a2-4446-4e62-a0ec-e8e04ac9888f_-_Contorno",
    "data-name": "7a1203a2-4446-4e62-a0ec-e8e04ac9888f - Contorno",
    d: "M10.368,30.535A1.732,1.732,0,0,1,8.636,28.8V8.982a1.732,1.732,0,0,1,2.588-1.506l17.424,9.909a1.732,1.732,0,0,1,0,3.011L11.224,30.309A1.731,1.731,0,0,1,10.368,30.535ZM12.1,11.959V25.825l12.189-6.934Z",
    transform: "translate(17.882 6.326)",
    fill: "#2f2f2f"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSobreYoutube);
export default __webpack_public_path__ + "static/media/Sobre_Youtube.30f421eebf6a607fb8fd00f17431143b.svg";
export { ForwardRef as ReactComponent };